import { BX, resolve } from '../internal/global';
import { ajax } from './ajax';

/**
 * Page updates after an ajax navigation and the history emulation of ajax components:
 * `BX.ajax.UpdatePage*`, `BX.ajax.history` and `BX.ajax.component`.
 *
 * Transcribed from `core_ajax.js`. `history` is reached through `BX.ajax.history` from markup the
 * server prints (`component_ajax.php` calls `top.BX.ajax.history.init(...)`) and from a
 * `javascript:` url this file writes itself, so its members keep reading each other off the
 * global. `init` and `put` use `this` and work only when called as methods, as they always did.
 */

ajax.UpdatePageData = function(arData: any): void
{
	if (arData.TITLE)
	{
		BX.ajax.UpdatePageTitle(arData.TITLE);
	}

	if (arData.WINDOW_TITLE || arData.TITLE)
	{
		BX.ajax.UpdateWindowTitle(arData.WINDOW_TITLE || arData.TITLE);
	}

	if (arData.NAV_CHAIN)
	{
		BX.ajax.UpdatePageNavChain(arData.NAV_CHAIN);
	}

	if (arData.CSS && arData.CSS.length > 0)
	{
		BX.loadCSS(arData.CSS);
	}

	if (arData.SCRIPTS && arData.SCRIPTS.length > 0)
	{
		const f = function(result: any, config: any, cb: any): void
		{
			if (!!config && BX.type.isArray(config.scripts))
			{
				for (let i = 0, l = arData.SCRIPTS.length; i < l; i++)
				{
					config.scripts.push({ isInternal: false, JS: arData.SCRIPTS[i] });
				}
			}
			else
			{
				BX.loadScript(arData.SCRIPTS, cb);
			}

			BX.removeCustomEvent('onAjaxSuccess', f);
		};
		BX.addCustomEvent('onAjaxSuccess', f);
	}
	else
	{
		const f1 = function(result: any, config: any, cb: any): void
		{
			if (BX.type.isFunction(cb))
			{
				cb();
			}
			BX.removeCustomEvent('onAjaxSuccess', f1);
		};
		BX.addCustomEvent('onAjaxSuccess', f1);
	}
};

ajax.UpdatePageTitle = function(title: any): void
{
	const obTitle = resolve('pagetitle');
	if (obTitle)
	{
		BX.remove(obTitle.firstChild);
		if (obTitle.firstChild)
		{
			obTitle.insertBefore(document.createTextNode(title), obTitle.firstChild);
		}
		else
		{
			obTitle.appendChild(document.createTextNode(title));
		}
	}
};

ajax.UpdateWindowTitle = function(title: any): void
{
	document.title = title;
};

ajax.UpdatePageNavChain = function(nav_chain: any): void
{
	const obNavChain = resolve('navigation');
	if (obNavChain)
	{
		obNavChain.innerHTML = nav_chain;
	}
};

const jsAjaxHistoryContainer = {
	arHistory: {} as Record<string, any>,

	put(hash: any, state: any): void
	{
		this.arHistory[hash] = state;
	},

	get(hash: any): any
	{
		return this.arHistory[hash];
	},
};

ajax.history = {
	expected_hash: '',

	obParams: null,

	obFrame: null,
	obImage: null,

	obTimer: null,

	bInited: false,
	bHashCollision: false,
	bPushState: typeof history.pushState === 'function',

	startState: null,

	init(this: any, obParams: any): void
	{
		if (BX.ajax.history.bInited)
		{
			return;
		}

		this.obParams = obParams;
		const obCurrentState = this.obParams.getState();

		if (BX.ajax.history.bPushState)
		{
			BX.ajax.history.expected_hash = window.location.pathname;
			if (window.location.search)
			{
				BX.ajax.history.expected_hash += window.location.search;
			}

			BX.ajax.history.put(obCurrentState, BX.ajax.history.expected_hash, '', true);
			// due to some strange thing, chrome calls popstate event on page start. so we should delay it
			setTimeout(() => {
				BX.bind(window, 'popstate', BX.ajax.history.__hashListener);
			}, 500);
		}
		else
		{
			BX.ajax.history.expected_hash = window.location.hash;

			if (!BX.ajax.history.expected_hash || BX.ajax.history.expected_hash == '#')
			{
				BX.ajax.history.expected_hash = '__bx_no_hash__';
			}

			jsAjaxHistoryContainer.put(BX.ajax.history.expected_hash, obCurrentState);
			BX.ajax.history.obTimer = setTimeout(BX.ajax.history.__hashListener, 500);

			if (BX.browser.IsIE())
			{
				BX.ajax.history.obFrame = document.createElement('IFRAME');
				BX.hide_object(BX.ajax.history.obFrame);

				document.body.appendChild(BX.ajax.history.obFrame);

				BX.ajax.history.obFrame.contentWindow.document.open();
				BX.ajax.history.obFrame.contentWindow.document.write(BX.ajax.history.expected_hash);
				BX.ajax.history.obFrame.contentWindow.document.close();
			}
			else if (BX.browser.IsOpera())
			{
				BX.ajax.history.obImage = document.createElement('IMG');
				BX.hide_object(BX.ajax.history.obImage);

				document.body.appendChild(BX.ajax.history.obImage);

				BX.ajax.history.obImage.setAttribute('src', 'javascript:location.href = \'javascript:BX.ajax.history.__hashListener();\';');
			}
		}

		BX.ajax.history.bInited = true;
	},

	__hashListener(e: any): void
	{
		e = e || (window as any).event || { state: false };

		if (BX.ajax.history.bPushState)
		{
			BX.ajax.history.obParams.setState(e.state || BX.ajax.history.startState);
		}
		else
		{
			if (BX.ajax.history.obTimer)
			{
				window.clearTimeout(BX.ajax.history.obTimer);
				BX.ajax.history.obTimer = null;
			}

			let current_hash;
			if (BX.ajax.history.obFrame != null)
			{
				current_hash = BX.ajax.history.obFrame.contentWindow.document.body.innerText;
			}
			else
			{
				current_hash = window.location.hash;
			}

			if (!current_hash || current_hash == '#')
			{
				current_hash = '__bx_no_hash__';
			}

			if (current_hash.indexOf('#') == 0)
			{
				current_hash = current_hash.substring(1);
			}

			if (current_hash != BX.ajax.history.expected_hash)
			{
				const state = jsAjaxHistoryContainer.get(current_hash);
				if (state)
				{
					BX.ajax.history.obParams.setState(state);

					BX.ajax.history.expected_hash = current_hash;
					if (BX.ajax.history.obFrame != null)
					{
						const __hash = current_hash == '__bx_no_hash__' ? '' : current_hash;
						if (window.location.hash != __hash && window.location.hash != '#' + __hash)
						{
							window.location.hash = __hash;
						}
					}
				}
			}

			BX.ajax.history.obTimer = setTimeout(BX.ajax.history.__hashListener, 500);
		}
	},

	put(this: any, state: any, new_hash: any, new_hash1?: any, bStartState?: any): void
	{
		if (this.bPushState)
		{
			if (bStartState)
			{
				BX.ajax.history.startState = state;
			}
			else
			{
				history.pushState(state, '', new_hash);
			}
		}
		else
		{
			if (typeof new_hash1 !== 'undefined')
			{
				new_hash = new_hash1;
			}
			else
			{
				new_hash = 'view' + new_hash;
			}

			jsAjaxHistoryContainer.put(new_hash, state);
			BX.ajax.history.expected_hash = new_hash;

			window.location.hash = BX.util.urlencode(new_hash);

			if (BX.ajax.history.obFrame != null)
			{
				BX.ajax.history.obFrame.contentWindow.document.open();
				BX.ajax.history.obFrame.contentWindow.document.write(new_hash);
				BX.ajax.history.obFrame.contentWindow.document.close();
			}
		}
	},

	checkRedirectStart(param_name: any, param_value: any): void
	{
		let current_hash = window.location.hash;
		if (current_hash.substring(0, 1) == '#')
		{
			current_hash = current_hash.substring(1);
		}

		const test = current_hash.substring(0, 5);
		if (test == 'view/' || test == 'view%')
		{
			BX.ajax.history.bHashCollision = true;
			// eslint-disable-next-line no-useless-concat -- split so an inline script never holds the tag
			document.write('<' + 'div id="__ajax_hash_collision_' + param_value + '" style="display: none;">');
		}
	},

	checkRedirectFinish(param_name: any, param_value: any): void
	{
		document.write('</div>');

		let current_hash = window.location.hash;
		if (current_hash.substring(0, 1) == '#')
		{
			current_hash = current_hash.substring(1);
		}

		BX.ready(() => {
			const test = current_hash.substring(0, 5);
			if (test == 'view/' || test == 'view%')
			{
				const obColNode = resolve('__ajax_hash_collision_' + param_value);
				const obNode = obColNode.firstChild;
				BX.cleanNode(obNode);
				obColNode.style.display = 'block';

				// IE, Opera and Chrome automatically modifies hash with urlencode, but FF doesn't ;-(
				if (test != 'view%')
				{
					current_hash = BX.util.urlencode(current_hash);
				}

				current_hash += (current_hash.indexOf('%3F') == -1 ? '%3F' : '%26') + param_name + '=' + param_value;

				const url = '/bitrix/tools/ajax_redirector.php?hash=' + current_hash;

				BX.ajax.insertToNode(url, obNode);
			}
		});
	},
};

const AjaxComponent = function(this: any, node: any): void
{
	this.node = node;
} as any;

AjaxComponent.prototype.getState = function(this: any): any
{
	const state: any = {
		node: this.node,
		title: window.document.title,
		data: resolve(this.node).innerHTML,
	};

	const obNavChain = resolve('navigation');
	if (obNavChain != null)
	{
		state.nav_chain = obNavChain.innerHTML;
	}

	BX.onCustomEvent(resolve(state.node), 'onComponentAjaxHistoryGetState', [state]);

	return state;
};

AjaxComponent.prototype.setState = function(state: any): void
{
	resolve(state.node).innerHTML = state.data;
	BX.ajax.UpdatePageTitle(state.title);

	if (state.nav_chain)
	{
		BX.ajax.UpdatePageNavChain(state.nav_chain);
	}

	BX.onCustomEvent(resolve(state.node), 'onComponentAjaxHistorySetState', [state]);
};

ajax.component = AjaxComponent;
